import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { removeNgStyles, createNewHosts, createInputTransfer } from '@angularclass/hmr';
/*
 * Platform and Environment providers/directives/pipes
 */
import { routing } from './app.routing';

// App is our top level component
import { AppComponent } from './app.component';
import { AppState, InternalStateType } from './app.service';
import { GlobalState } from './global.state';
import { NgaModule } from './theme/nga.module';
import { PagesModule } from './pages/pages.module';
//services
import {MasterRepo} from './common/repositories';
import {CanActivateTeam,AuthService,CacheService} from './common/services/permission';
import {LoginService} from './pages/login'
import { DatepickerConfig } from 'ngx-bootstrap';

import { DisableDateService } from '../app/common/services/disable-date-picker/disable-date-picker.service'; 
import { LabelPipe } from './theme/pipes/label.pipe';
import { CommonService } from './common/services/common.service';
import { TimeFormatService } from './common/services/time-format.service';
import { TTLCacheService } from './common/services/cache.service';
import { HttpInterceptorService } from './common/services/httpInterceptor.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { environment } from './environment';
import { UpdateNotificationComponent } from './common/components/update-notification/update-notification.component';
// Application wide providers
const APP_PROVIDERS = [
  AppState,
  GlobalState,AuthService,CacheService,MasterRepo,TTLCacheService,
  CanActivateTeam,LoginService,CommonService,TimeFormatService,
  LabelPipe
];

export type StoreType = {
  state: InternalStateType,
  restoreInputValues: () => void,
  disposeOldHosts: () => void
};

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  declarations: [
    AppComponent,
    UpdateNotificationComponent
  ],
  entryComponents:[],
  imports: [ // import Angular's modules
    BrowserModule,
    HttpClientModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgaModule.forRoot(),
    PagesModule,
    routing,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [ // expose our Services and Providers into Angular's dependency injection
    APP_PROVIDERS,
    DisableDateService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
  ],
  bootstrap: [AppComponent]
})

export class AppModule {}
